// NAT-2562 — the notifications box on Operativa.
import useSWR from 'swr';

import axiosInstance, { endpoints, fetcher } from 'src/utils/axios';
import type { IAdminNotification, IAdminNotificationAck } from 'src/types/admin-notification';

/** Active and not yet acknowledged, newest first — the backend decides both. */
export function useAdminNotifications() {
  return useSWR<IAdminNotification[]>(endpoints.admin.notifications.root, fetcher);
}

// `fetcher` unwraps the `{ status, message, data }` envelope for GETs; axiosInstance's own writes
// are not unwrapped by any interceptor, so this one does it itself (as src/api/scouting.ts does).
export const acknowledgeAdminNotification = (id: string) =>
  axiosInstance
    .post<{ data: IAdminNotificationAck }>(endpoints.admin.notifications.acknowledge(id))
    .then((r) => r.data.data);
